import { AcceptFileMutationDataType } from '@/modules/FileList/queries/acceptFile/acceptFileMutation.type.ts';
import { fetchApi } from '@/config/axiosSetting.ts';

export const acceptFileMutationFunction = ({
  fileId,
  relatedFilesIds = [],
}: AcceptFileMutationDataType) =>
  fetchApi.post(`actions/${fileId}/accept_case/`, {
    files_list: relatedFilesIds,
  });
